module.exports = __webpack_public_path__ + "static/media/fork.906b4baa.svg";